import React from 'react';
import { Typography, Box } from '@mui/material';

/**
 * Check-Now brand wordmark matching marketing website:
 * - "Check" in dark navy (#0B2D4D)
 * - "-Now" in blue gradient (#1EA5E8 → #0B5FAF)
 * - Montserrat, heavy weight
 */
export const CHECK_NAVY = '#0B2D4D';
export const NOW_GRADIENT_TOP = '#1EA5E8';
export const NOW_GRADIENT_BOTTOM = '#0B5FAF';

export interface BrandWordmarkProps {
  variant?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'subtitle1' | 'body1';
  fontSize?: string | number;
  fontWeight?: number;
  component?: React.ElementType;
  sx?: object;
  /** Use compact style (single line, smaller) for sidebars */
  compact?: boolean;
  /** White "Check" + brighter gradient "-Now" for dark backgrounds (e.g. navy header) */
  onDark?: boolean;
}

const NOW_GRADIENT_TOP_ON_DARK = '#7DD3FC';
const NOW_GRADIENT_BOTTOM_ON_DARK = '#38BDF8';

export default function BrandWordmark({
  variant = 'h4',
  fontSize,
  fontWeight = 900,
  component = 'span',
  sx = {},
  compact = false,
  onDark = false,
}: BrandWordmarkProps) {
  const baseSx = {
    fontFamily: "'Montserrat', sans-serif",
    fontWeight,
    letterSpacing: '-0.02em',
    display: 'inline',
    ...(compact && { whiteSpace: 'nowrap' as const }),
    ...sx,
  };

  return (
    <Typography
      variant={variant}
      component={component}
      sx={{
        ...baseSx,
        ...(fontSize && { fontSize }),
      }}
    >
      <Box component="span" sx={{ color: onDark ? '#ffffff' : CHECK_NAVY }}>
        Check
      </Box>
      <Box
        component="span"
        sx={{
          background: onDark
            ? `linear-gradient(180deg, ${NOW_GRADIENT_TOP_ON_DARK} 0%, ${NOW_GRADIENT_BOTTOM_ON_DARK} 100%)`
            : `linear-gradient(180deg, ${NOW_GRADIENT_TOP} 0%, ${NOW_GRADIENT_BOTTOM} 100%)`,
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
        }}
      >
        -Now
      </Box>
    </Typography>
  );
}
